import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            精选四大分类，找到你最喜欢的漫画类型
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[3/2] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name}漫画 - 皮皮喵漫画`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
                <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center text-2xl md:text-3xl bg-white/20 backdrop-blur-sm rounded-full mb-3">
                  <i className={`${cat.icon} text-white`}></i>
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white font-heading">
                  {cat.name}
                </h3>
                <p className="mt-1 text-xs text-white/80">
                  {cat.count}+ 部作品
                </p>
                <p className="mt-1 text-xs text-white/70 line-clamp-1 max-w-[200px]">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}